<template>
  <div class="animated fadeIn list-of-ar">
    <b-card>
      <div slot="header">
        List of Account Receivable
        <div class="card-header-actions mt-0 mb-0">
          <b-dropdown text="Import/Upload" variant="primary mr-1">
            <b-dropdown-item @click="showUploadFrm = true"
              >Start Upload</b-dropdown-item
            >
            <b-dropdown-item @click="showUploadedCancelFrm = true"
              >Cancel Uploaded</b-dropdown-item
            >
          </b-dropdown>
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">
            <span v-if="model.posting == 1">View</span
            ><span v-else>Edit</span></b-button
          >
          <!-- <b-dropdown text="Edit" variant="primary mr-1" >
            <b-dropdown-item @click="edit"> <span v-if="(model.posting == 1)">View</span><span v-else>Edit</span></b-dropdown-item>
            <b-dropdown-item @click="postAll_Confirm=true">Cancelation</b-dropdown-item>
            <b-dropdown-item @click="postAll_Confirm=true">Reissued</b-dropdown-item>
          </b-dropdown> -->
          <b-button variant="primary mr-1" @click="deleteConfirm"
            >Delete</b-button
          >
          <b-dropdown text="Posting" variant="primary mr-1">
            <b-dropdown-item @click="posting" :disabled="model.posting == 1"
              >Posting</b-dropdown-item
            >
            <b-dropdown-item @click="posting" :disabled="model.posting != 1"
              >Un Posting</b-dropdown-item
            >
            <b-dropdown-item @click="postAll_Confirm = true"
              >Post/UnPost All</b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown text="Print" variant="primary mr-1">
            <b-dropdown-item @click="print">Billing/Invoice</b-dropdown-item>
            <b-dropdown-item
              @click="printselected"
              :disabled="selected.length == 0"
              >Billing Selected ({{ selected.length }})
            </b-dropdown-item>
            <b-dropdown-item @click="printkwitansi">Kwitansi</b-dropdown-item>
            <b-dropdown-item
              @click="printkwitansis"
              :disabled="selected.length == 0"
              >Kwitansi({{ selected.length }} yg terpilih)
            </b-dropdown-item>
            <b-dropdown-item @click="printjv" :disabled="model.posting == 0"
              >Journal Voucher</b-dropdown-item
            >
            <b-dropdown-item @click="printlist">List AR Inv.</b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="payment()"
            >Payment/Settlement</b-button
          >
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i>Export</b-button
          >
          <b-button variant="primary mr-1" @click="togleFilter()"
            ><i class="fa fa-filter"></i> Filter</b-button
          >
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close</b-button
          >
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Invoice Date</label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.tgl1"
              type="date"
              style="width: 18% !important"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text">-</span></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.tgl2"
              type="date"
              style="width: 18% !important"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="pt-2">&nbsp;Source </span></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.invmanual"
              :plain="true"
              :options="invSources"
            ></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Invoice Number</label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.nomor"
              placeholder="Invoice No. (% for wildcard)"
              style="width: 33% !important"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="pt-2">&nbsp;Sales </span></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.deffered"
              :plain="true"
              :options="invDeffers"
              v-b-tooltip.hover
              title="Actual/UnEarned"
              class="ml-1"
            ></b-form-select>
            <b-input-group-prepend
              ><span class="ml-2 pt-2"
                >Posted &nbsp;</span
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.posting"
              :plain="true"
              :options="dataList.postingStatus"
              style="width: 9% !important"
            ></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Outstanding Status</label></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.outstand"
              :plain="true"
              :options="dataList.YesNoAll"
            ></b-form-select>
            <b-input-group-prepend
              ><span class="ml-2 pt-2"
                >Ost.group &nbsp;</span
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.ostStatuskey"
              :plain="true"
              :options="dataList.ostandStatus"
              class="ml-1"
              style="width: 14% !important"
              v-b-tooltip.hover
              title="Outstanding Group"
            ></b-form-select>
            <b-input-group-prepend
              ><span class="ml-2 pt-2">Canceled</span></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.canceled"
              :plain="true"
              :options="dataList.YesNoAll"
              class="ml-1"
              v-b-tooltip.hover
              title="Cancelation&Reissued"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-row no-gutters>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Customer</label></b-input-group-prepend
                >
                <b-form-input v-model="tblData.customer"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCustomerShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="pt-2"
                    >&nbsp; Desc &nbsp;</span
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.uraian"
                  placeholder="Invoice Description"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Order Number</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.po"
                  placeholder="Purch. Order#"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="pt-2"
                    >&nbsp; Dimension &nbsp;</span
                  ></b-input-group-prepend
                >
                <b-form-select
                  v-model="tblData.DimCol"
                  :plain="true"
                  :options="dimension"
                ></b-form-select>
                <b-form-input
                  v-model="tblData.DimVal"
                  placeholder="Dimension Value"
                  class="ml-1"
                  style="width: 35% !important"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend
              ><label>Bentuk Bayar</label></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.pack_name"
              :plain="true"
              :options="paymentForms"
            ></b-form-select>
            <b-input-group-prepend
              ><span class="ml-2 pt-2"
                >AR Group &nbsp;</span
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.postgroup"
              :plain="true"
              :options="postGroups"
            ></b-form-select>
            <b-input-group-append>
              <b-button
                variant="success"
                size="sm"
                @click="search()"
                class="ml-3"
              >
                <i class="fa fa-refresh"></i> Apply Filter</b-button
              >
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
                >Clear Filter</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(selected)="data">
          <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event, data.item)"
            :data-arinvKey="data.item.arinvKey"
            :checked="ischeckedjurnal(data.item.arinvKey)"
          />
        </template>
        <template v-slot:head(selected)="data">
          <a
            href="javascript:void(0)"
            class="text-danger"
            @click="checkedclear()"
          >
            <i class="fa fa-eraser"></i>
          </a>
        </template>
        <template v-slot:cell(action)="data">
          <b-dropdown
            dropright
            variant="outline-secondary"
            toggle-class="text-decoration-none"
            no-caret
            size="sm"
            style="margin: -10px"
          >
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item
              @click="rowEdit(data.item)"
              href="#"
              style="padding: 0 !important"
              >Edit/View</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPost(data.item)"
              href="#"
              v-if="data.item.posting == 1"
              style="padding: 0 !important"
              >Un Posting</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPost(data.item)"
              href="#"
              v-if="data.item.posting == 0"
              style="padding: 0 !important"
              >Posting</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPrint(data.item)"
              href="#"
              style="padding: 0 !important"
              >Print Invoice/Bill</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPrintkwitansi(data.item)"
              href="#"
              style="padding: 0 !important"
              >Print Kwitansi</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPrintjv(data.item)"
              href="#"
              :disabled="data.item.posting == 0"
              style="padding: 0 !important"
              >Print JV</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowDel(data.item)"
              href="#"
              :disabled="data.item.posting == 1"
              style="padding: 0 !important"
            >
              Delete</b-dropdown-item
            >
          </b-dropdown>
        </template>
        <template v-slot:cell(invoiceno)="data">
          <div v-if="data.item.posting == 0" style="background-color: yellow">
            {{ data.item.invoiceno }}
          </div>
          <div v-else>{{ data.item.invoiceno }}</div>
        </template>
        <template v-slot:cell(ordernumber)="data">
          <span v-if="data.item.kontrakprd">{{ data.item.kontrakprd }}</span>
          <span v-else>{{ data.item.ordernumber }}</span>
        </template>

        <template v-slot:cell(invdate)="data">
          {{ data.item.invdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(totalinv)="data">
          <div v-if="data.item.posting == 0" style="background-color: yellow">
            {{ data.item.totalinv | numFormat("0,0.00") }}
          </div>
          <div v-else>
            {{ data.item.totalinv | numFormat("0,0.00") }}
          </div>
        </template>

        <template v-slot:cell(outstand)="data">
          {{ data.item.outstand | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(colleNote)="data">
          <span v-if="data.item.colleNote"
            ><b-link @click.stop="showActionHistory(data.item)">{{
              data.item.colleNote
            }}</b-link></span
          >
          <span v-else>{{ data.item.colleNote }}</span>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-1">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="5">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-1 pr-2"
                >Limit per page</span
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="limit"
              type="number"
              class="mr-2"
              v-b-tooltip.hover
              :title="`${limit} records`"
              style="max-width:80px; !important;"
            ></b-form-input>
            <b-pagination
              v-if="pagination"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3">
          <div class="text-right pt-1">
            <span style="background-color: yellow"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>
      </b-row>
      <b-modal
        v-model="showDelConfirm"
        title="Delete Record?"
        :centered="true"
        @ok="deleteData"
      >
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">
          Warning: You can't undo this action.
        </p>
      </b-modal>
      <b-modal
        v-model="showPostingConfirm"
        title="Posting Record?"
        :centered="true"
        @ok="postingData"
      >
        <p class="mb-1">
          The selected a row of data will be Posted to Accounting?
        </p>
        <p class="font-weight-bold m-0 text-danger">
          You can unpost as long as <strong>Accounting Periode</strong> stil
          open
        </p>
      </b-modal>
      <b-modal
        v-model="showUnpostConfirm"
        title="Un Posting Record?"
        :centered="true"
        @ok="unpostData"
      >
        <p class="mb-1">
          The selected a row of data will be UnPosted from Accounting?
        </p>
        <p class="font-weight-bold m-0 text-danger">
          Data Journal will be removed from <strong>Accounting</strong>
        </p>
      </b-modal>
    </b-card>

    <b-modal
      v-model="postAll_Confirm"
      title="Posting/UnPosting multiple records"
      :centered="true"
      hide-footer
    >
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 100px !important"
            >Periode</label
          ></b-input-group-prepend
        >
        <vue-monthly-picker
          style="width: 333px"
          v-model="postAllfrm.invdate"
          :state="!$v.postAllfrm.invdate.$error"
          dateFormat="MMMM YYYY"
          :monthLabels="monthLabels"
        ></vue-monthly-picker>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 100px !important"
            >AR Type/Group</label
          ></b-input-group-prepend
        >
        <b-form-select
          v-model="postAllfrm.artype"
          :plain="true"
          :options="artypes"
          :state="!$v.postAllfrm.artype.$error"
        ></b-form-select>
      </b-input-group>
      <div style="text-align: right; display: blocked" class="mt-3">
        <b-button variant="success" @click="postAll"
          ><i class="fa fa-paper-plane"></i> Posting All</b-button
        >
        <b-button variant="danger" class="ml-1" @click="unpostAll">
          <i class="fa fa-undo"></i> Un Posting All</b-button
        >
        <b-button
          variant="secondary"
          class="ml-1"
          @click="postAll_Confirm = false"
        >
          <i class="fa fa-close"></i> Close</b-button
        >
      </div>
    </b-modal>

    <b-modal
      v-model="exportConfirm"
      title="Export Data Choices"
      size="sm"
      @ok="exportData"
    >
      <b-form-radio-group
        id="chkExport"
        name="exportMenus"
        v-model="exportChoice"
        stacked
      >
        <b-form-radio value="exportxls">EXCEL List of Invoice</b-form-radio>
        <b-form-radio value="exportcsv">CSV e-Faktur</b-form-radio>
      </b-form-radio-group>
    </b-modal>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>

    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      hide-footer
    >
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
      <b-row class="justify-content-center mt-1">
        <b-button
          variant="primary"
          v-if="isprintjv == true"
          @click.stop="editjv"
          >Edit Journal</b-button
        >
        <b-button variant="secondary" class="ml-2" @click="showReport = false">
          Close</b-button
        >
      </b-row>
    </b-modal>

    <b-modal
      v-model="showUploadFrm"
      header-bg-variant="primary"
      size="lg"
      title="Import/Upload AR INVOICE"
      :centered="true"
      @ok="handleOk"
      ok-title="Process"
    >
      <b-form @submit.stop.prevent="uploadinv">
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>AR Type/Group </label></b-input-group-prepend
              >
              <b-form-select
                v-model="frmdata.artype"
                :plain="true"
                :options="arWithSale"
                :state="!$v.frmdata.artype.$error"
              ></b-form-select>
            </b-input-group>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label> &nbsp;</label></b-input-group-prepend
              >
              <b-input-group-prepend>
                <b-link @click="downloadtemplate"
                  ><i class="fa fa-paperclip"></i>
                  EkosSystem-AR-upload-template.xlsx</b-link
                >
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-row>
        <b-input-group>
          <b-input-group-prepend
            ><label>Choose *.XLSX file</label></b-input-group-prepend
          >
          <b-form-file
            v-model="fileXlsx"
            :state="Boolean(fileXlsx)"
            placeholder="Choose a XLSX file..."
            drop-placeholder="Drop XLSX file here..."
          ></b-form-file>
        </b-input-group>
        <b-row no-gutters>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><span class="p-2"
                  >Excel Worksheet Name
                </span></b-input-group-prepend
              >
              <b-form-input
                v-model="frmdata.sheetName"
                :state="!$v.frmdata.sheetName.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-append
                ><label class="input-group-text"
                  >Data staring from Row
                </label></b-input-group-append
              >
              <b-form-input
                v-model="frmdata.startRow"
                type="number"
                :state="!$v.frmdata.startRow.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-card class="ColsDefine">
          <strong>Define Excel Column name for each AR INVOICE fields</strong>
          <b-row>
            <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Invoice Number</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.invoiceno"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.invoiceno.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Invoice Date</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.invdate"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.invdate.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Customer Code</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.CustCode"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.CustCode.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Customer Name</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.CustName"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.CustName.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Description #1</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.uraian1"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.uraian1.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Description #2</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.uraian2"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Order Number</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.ordernumber"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Gross Value</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.ttlgross"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.ttlgross.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Discount Value</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.ttldiskon"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Netto Value</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.ttlnetto"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.ttlnetto.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>VAT Value</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.ttlvat"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.ttlvat.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Total Due Value </label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.ttlamtdue"
                  :plain="true"
                  :options="kolomXls"
                  :state="!$v.frmdata.ttlamtdue.$error"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Currency</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.matauang"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Exch.Rate</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.kursPPN"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend
                  ><label>N P W P</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.npwp"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Nama WP</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.npwp_name"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>No. Faktur Pajak</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.nofaktur"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Tgl. Faktur Pajak</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.tglfaktur"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Sales AE</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.accexec"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Related To Invoice#</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.invoicereff"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <div
                style="font-size: smaller; display: block; text-align: right"
              >
                Canceled/Manual Inv.
              </div>
            </b-col>
            <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Cashflow Code</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.kodecash"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group v-for="dim in dimension" :key="dim.value">
                <b-input-group-prepend
                  ><label>{{ dim.text }} Code</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata[`${dim.value}`]"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
              <b-input-group class="mt-5">
                <b-input-group-prepend
                  ><label>Bentuk Bayar</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.pack_name"
                  :plain="true"
                  :options="kolomXls"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
        </b-card>
      </b-form>
    </b-modal>
    <b-modal
      v-model="showUploadedCancelFrm"
      header-bg-variant="danger"
      title="Cancel Uploaded AR INVOICE"
      :centered="true"
      hide-footer
    >
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 100px !important"
            >Upload Date</label
          ></b-input-group-prepend
        >
        <b-form-input
          v-model="postAllfrm.invdate"
          type="date"
          :state="!$v.postAllfrm.invdate.$error"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 100px !important"
            >AR Type/Group</label
          ></b-input-group-prepend
        >
        <b-form-select
          v-model="postAllfrm.artype"
          :plain="true"
          :options="artypes"
          :state="!$v.postAllfrm.artype.$error"
        ></b-form-select>
      </b-input-group>
      <div style="text-align: right; display: blocked" class="mt-3">
        <b-button variant="danger" class="ml-1" @click="unuploadinv">
          <i class="fa fa-undo"></i> Process</b-button
        >
        <b-button
          variant="secondary"
          class="ml-1"
          @click="showUploadedCancelFrm = false"
        >
          <i class="fa fa-close"></i> Close</b-button
        >
      </div>
    </b-modal>

    <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>

    <b-modal
      v-model="showPaymentForm"
      scrollable
      size="xl"
      title="AR Payment/Settlement History"
      :centered="true"
      hide-footer
    >
      <b-form-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Invoice Number</label></b-input-group-prepend
            >
            <b-form-input v-model="paymdata.invoiceno" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Invoice Date</label></b-input-group-prepend
            >
            <b-form-input
              v-model="paymdata.invdate"
              type="date"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-input-group>
        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
        <b-form-input readonly v-model="paymdata.custinfo"></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label>Description</label></b-input-group-prepend
        >
        <b-form-input v-model="paymdata.uraian1" readonly></b-form-input>
        <b-form-input
          v-model="paymdata.uraian2"
          readonly
          class="ml-1"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label>Purchase Order#</label></b-input-group-prepend
        >
        <b-form-input readonly v-model="paymdata.ordernumber"></b-form-input>
        <b-form-radio-group
          class="mt-2"
          v-model="paymdata.proforma"
          name="radioProforma"
          disabled
        >
          <b-form-radio value="0">Actual Invoice</b-form-radio>
          <b-form-radio value="1">Proforma (PBB) Invoice</b-form-radio>
        </b-form-radio-group>
      </b-input-group>
      <b-form-row>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Invoice Amount</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 60px">{{
                paymdata.matauang
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right"
              separator=","
              v-model="paymdata.totalinv"
              :precision="2"
              readonly
            ></my-number>
          </b-input-group>
        </b-col>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Related to other Invoice #</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.invoicereff"
              readonly=""
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-card no-body class="mb-1">
        <div class="report-wraper">
          <table style="width: 100%">
            <thead>
              <tr>
                <th width="80px">Settlement Date</th>
                <th width="110px">Doc. Number</th>
                <th width="110px">Settlement Method</th>
                <th>Description</th>
                <th width="90px">Input By</th>
                <th width="140px" style="text-align: right">Credit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in paymdata.paymLines" :key="row.tablekey">
                <td :class="row.kelas">
                  {{ row.tanggal | moment("DD MMM YYYY") }}
                </td>
                <td :class="row.kelas">{{ row.nomor }}</td>
                <td :class="row.kelas">{{ row.paymethod }}</td>
                <td :class="row.kelas">{{ row.uraian }}</td>
                <td :class="row.kelas">{{ row.createby }}</td>
                <td :class="row.kelas" style="text-align: right">
                  {{ row.nilaibayar | numFormat("0,0.00") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-row class="mt-1">
        <b-col lg="6">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend
                ><label
                  style="text-align: left; width: 158px; padding-left: 16px"
                  >Total Settlement</label
                ></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{
                  paymdata.matauang
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="paymdata.totalsettle"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
          </div>
        </b-col>
        <b-col lg="6">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend
                ><label
                  style="text-align: left; width: 158px; padding-left: 16px"
                  >Oustanding</label
                ></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{
                  paymdata.matauang
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="paymdata.outstand"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-model="showKwitansiForm"
      scrollable
      size="lg"
      title="Konfirmasi - Print Kwitansi "
      :centered="true"
      hide-footer
    >
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 150px !important"
            >Terima dari</label
          ></b-input-group-prepend
        >
        <b-form-input v-model="kwitansi.kwitansidari"></b-form-input>
      </b-input-group>
      <b-input-group>
        <!-- <b-input-group-prepend><label style="width: 150px !important">Alamat</label></b-input-group-prepend> -->
        <b-input-group-prepend
          ><label style="width: 150px !important"
            >Untuk Pembayaran</label
          ></b-input-group-prepend
        >
        <!-- <b-form-textarea :rows="3" :max-rows="3" v-model="kwitansi.kwitansiaddr"  ></b-form-textarea> -->
        <b-form-textarea
          :rows="3"
          :max-rows="3"
          v-model="kwitansi.kwitansiFor"
        ></b-form-textarea>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 150px !important"
            >Total Invoice</label
          ></b-input-group-prepend
        >
        <b-input-group-prepend
          ><span class="input-group-text" style="width: 60px">{{
            kwitansi.matauang
          }}</span></b-input-group-prepend
        >
        <my-number
          class="form-control text-right"
          separator=","
          v-model="kwitansi.totalinv"
          :precision="2"
          readonly
        ></my-number>
      </b-input-group>
      <b-row class="justify-content-center mt-1">
        <b-button variant="primary" @click="printkwitansiok"
          ><i class="fa fa-print"></i> Print Kwitansi</b-button
        >
        <b-button
          variant="danger"
          class="ml-1"
          @click.stop="showKwitansiForm = false"
        >
          <i class="fa fa-undo"></i> Cancel</b-button
        >
      </b-row>
    </b-modal>

    <b-modal
      v-model="actionHistoryShow"
      header-bg-variant="primary"
      title="Collection Action History"
      size="lg"
      :centered="true"
      ok-only
    >
      <b-input-group>
        <b-input-group-prepend
          ><label>Invoice Number</label></b-input-group-prepend
        >
        <b-form-input v-model="model.invoiceno" readonly></b-form-input>
        <b-form-radio-group class="mt-2" v-model="model.proforma" disabled>
          <b-form-radio value="0">Invoice Actual</b-form-radio>
          <b-form-radio value="1">Unearned Income</b-form-radio>
        </b-form-radio-group>
        <b-input-group-prepend
          ><span class="p-2">Invoice Date</span></b-input-group-prepend
        >
        <b-form-input
          :value="model.invdate | moment('DD MMM YYYY')"
          disabled
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
        <b-form-input
          readonly
          v-model="model.custinfo"
          style="width: 30% !important"
        ></b-form-input>
        <b-input-group-prepend
          ><span class="p-2">Sales Order No.</span></b-input-group-prepend
        >
        <b-form-input readonly v-model="model.ordernumber"></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label>Description</label></b-input-group-prepend
        >
        <b-form-input v-model="model.uraian1" readonly></b-form-input>
        <b-form-input
          v-model="model.uraian2"
          readonly
          class="ml-1"
        ></b-form-input>
      </b-input-group>
      <b-form-row>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Invoice Amount</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 60px">{{
                model.matauang
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right"
              separator=","
              v-model="model.totalinv"
              :precision="2"
              readonly
            ></my-number>
          </b-input-group>
        </b-col>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Reff other Invoice#</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.invoicereff"
              readonly=""
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <div class="report-wraper">
        <table width="100%">
          <thead>
            <tr>
              <th width="120px">Action Date</th>
              <th>Collectio Note</th>
              <th width="100px">Input By</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in actionHistory" :key="row.ARfollowID">
              <td>
                {{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
              </td>
              <td>{{ row.pesan }}</td>
              <td>{{ row.createby }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-ar {
  table {
    td:nth-child(1) {
      width: auto;
    }
    td:nth-child(2) {
      width: auto;
    }
    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import VueMonthlyPicker from "vue-monthly-picker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import lkuCustomer from "../lookup/lkuCustomer";
import crud from "../../apis/crud";
import arinv from "../../apis/arinv";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, VueMonthlyPicker, Loading, lkuCustomer },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      sheetName: { required },
      startRow: { required },
      CustCode: { required },
      CustName: { required },
      uraian1: { required },
      invoiceno: { required },
      invdate: { required },
      artype: { required },
      // matauang: { required:false },
      ttlgross: { required },
      ttlnetto: { required },
      ttlvat: { required },
      ttlamtdue: { required },
    },
    postAllfrm: {
      artype: { required },
      invdate: { required },
    },
  },
  data() {
    return {
      actionHistoryShow: false,
      actionHistory: [],
      lkuCustomerShow: false,
      postAll_Confirm: false,
      postAllfrm: { artype: "", invdate: this.$store.state.user.tglaktif },
      exportConfirm: false,
      exportChoice: "exportxls",
      monthLabels: dropdown.monthLabels,
      showPaymentForm: false,
      paymdata: { paymLines: [] },
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      showKwitansiForm: false,
      kwitansi: {
        kwitansidari: "",
        kwitansiaddr: "",
        kwitansiFor: "",
        totalinv: 0,
        matauang: "",
        arinvKey: "",
      },
      showUploadFrm: false,
      showUploadedCancelFrm: false,
      fileXlsx: null,
      frmdata: {
        sheetName: "AR_LIST",
        startRow: 8,
        invoiceno: "A",
        invdate: "B",
        CustCode: "C",
        CustName: "D",
        uraian1: "E",
        uraian2: "",
        matauang: "",
        ttlgross: "H",
        ttldiskon: "",
        ttlnetto: "J",
        ttlvat: "K",
        ttlamtdue: "L",
      },
      kolomXls: [
        "",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "AA",
        "AB",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AH",
        "AI",
        "AJ",
        "AK",
        "AL",
        "AM",
        "AN",
        "AO",
        "AP",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AV",
        "AW",
        "AX",
        "AY",
        "AZ",
      ],
      isLoading: false,
      isprintjv: false,
      showReport: false,
      reportUrl: null,
      items: [],
      pagination: false,
      limit: 20,
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "invdate",
        sortDesc: true,
        DimCol: "Dim1",
        outstand: "1",
      },

      model: {},
      artypes: [],
      arWithSale: [],
      selected: [],
      invSources: [
        { value: "", text: "--- ALL ---" },
        { value: "0", text: "Upload/Import" },
        { value: "1", text: "Manual Entry" },
      ],
      invDeffers: [
        { value: "", text: "--- ALL ---" },
        { value: "0", text: "Actual Invoice" },
        { value: "1", text: "Unearned Invoice" },
      ],
      postGroups: [{ value: "", text: "--- ALL ---" }],
      paymentForms: [{ value: "", text: "--- ALL ---" }],
      dataList: {
        YesNoAll: dropdown.ostandStatus,
        postingStatus: dropdown.postingStatus,
        ostandStatus: [{ value: "", text: "" }],
      },
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "selected",
          label: "",
          thStyle: "width:20px",
          thClass: "text-center",
          tdClass: "text-center",
        },

        {
          key: "invoiceno",
          thStyle: "width:150px",
          label: "Invoice Number",
          sortable: true,
        },
        {
          key: "invdate",
          thStyle: "width:90px",
          label: "Inv. Date",
          sortable: true,
        },
        {
          key: "custinfo",
          label: "Customer",
          sortable: true,
        },
        {
          key: "uraian",
          label: "Description",
          sortable: true,
        },
        {
          key: "ordernumber",
          label: "No. Order",
          sortable: true,
        },
        {
          key: "pack_name",
          label: "Payment",
          sortable: true,
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true,
        },
        {
          key: "totalinv",
          label: "Invoice Amount",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand",
          label: "Outstanding",
          thStyle: "width:150px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nomorbank",
          label: "Bank/Cash Trx.#",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "colleNote",
          thStyle: "width:200px",
          label: "Note",
          sortable: true,
        },
        {
          key: "accexec",
          label: "AE",
          sortable: true,
        },
        {
          key: "canceled",
          label: "Cancel",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "invoicereff",
          label: "Reference.#",
          sortable: true,
        },
      ];
      const dims = this.$store.state.dimension;
      for (let i = 0; i < dims.length; i += 1) {
        fields.push({
          key: `${dims[i].value}Txt`,
          // thStyle: "width:100px",
          label: dims[i].text,
          sortable: true,
        });
      }

      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    invalidPostAll() {
      this.$v.postAllfrm.$touch();
      return this.$v.postAllfrm.$invalid;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(
        (d) => d.value === newval
      ).text;
    },
    limit: function (newVal) {
      setTimeout(() => {
        if (this.limit == newVal) {
          this.tblData.limit = newVal;
        }
      }, 500);
    },
  },
  created: function () {
    if (this.$route.params.nomor) {
      this.clearFilter();
      this.tblData.nomor = this.$route.params.nomor;
    }
    setTimeout(async () => {
      const [a, b, c, f] = await Promise.all([
        arinv.postgroup(),
        arinv.outstandstatus(),
        crud.list({ tablename: "upload-arinv" }),
        arinv.paymentform(),
      ]);
      this.artypes = a;
      // this.dataList.ostandStatus = b;
      this.dataList.ostandStatus = this.dataList.ostandStatus.concat(b);

      // this.artypes = await arinv.postgroup();
      this.postGroups = this.artypes.reduce(
        (newArr, item) => {
          if (item.saleCode) {
            this.arWithSale.push(item);
          }
          newArr.push(item);
          return newArr;
        },
        [{ value: "", text: "--- ALL ---" }]
      );
      const [uploadConfig] = c;
      // console.log(uploadConfig);
      for (var key in uploadConfig) {
        if (uploadConfig[key] != "null" && uploadConfig[key] != "") {
          this.frmdata[key] = uploadConfig[key];
        }
      }
      this.paymentForms = f.reduce(
        (newArr, item) => {
          newArr.push(item);
          return newArr;
        },
        [{ value: "", text: "--- ALL ---" }]
      );
    }, 1000);
    // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    // this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
    // this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
  },
  methods: {
    onSelectLkuCustomer: async function (_selected) {
      this.tblData.customer = _selected.CustName.trim();
      this.tblData.custcode = _selected.CustCode;
      // this.tblData.customer_id = _selected.customer_id;
      this.lkuCustomerShow = false;
    },
    ischeckedjurnal(val) {
      const findjv = this.selected.find((x) => x === val);
      if (findjv) {
        return "checked";
      } else {
        return "";
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes =
        document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach((element) => {
        element.checked = false;
      });
    },
    checkedjurnal(item, record) {
      this.rowClicked(record);
      const arinvKey = item.target.attributes["data-arinvKey"].value;
      if (item.target.checked) {
        const findjv = this.selected.find((x) => x === arinvKey);
        if (!findjv) {
          this.selected.push(arinvKey);
        }
      } else {
        const findIdx = this.selected.findIndex((x) => x === arinvKey);
        this.selected.splice(findIdx, 1);
      }
    },
    data: async function (ctx) {
      const tblOrder = {
        sortBy: this.tblData.sortBy,
        sortDesc: this.tblData.sortDesc,
      };
      this.pagination = false;
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.arinvlist) {
        this.tblData[key] = filter.arinvlist[key];
        filtered = true;
      }
      if (filtered === true) {
        this.tblData.tgl1 = filter.arinvlist.tgl1 || "";
        this.tblData.tgl2 = filter.arinvlist.tgl2 || "";
        this.showFilter = filtered;
        delete filter.arinvlist;
        this.$store.commit("filter", filter);
        let autoRefresh = true;
        if (this.tblData.page == 1) {
          if (
            tblOrder.sortBy == this.tblData.sortBy &&
            tblOrder.sortDesc == this.tblData.sortDesc
          ) {
            autoRefresh = false;
          } else autoRefresh = true;
        }
        if (autoRefresh == false) {
          this.isLoading = true;
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          try {
            const list = await arinv.list(this.tblData);
            this.items = list;
            this.isLoading = false;
            this.pagination = true;
            return list;
          } catch (error) {
            this.isLoading = false;
            if (error.sql) {
              toastr.error(error.sql, "ERROR MESSAGE", 10000);
            } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
            } else if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      } else {
        this.isLoading = true;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        try {
          const list = await arinv.list(this.tblData);
          this.items = list;
          this.isLoading = false;
          this.pagination = true;
          return list;
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page = 1;
      this.refresh();
    },
    clearFilter(ctx) {
      this.tblData.custcode = "";
      this.tblData.customer = "";
      this.tblData.po = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.posting = "";
      this.tblData.postgroup = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
      this.tblData.invmanual = "";
      this.tblData.ostStatuskey = "";
      this.tblData.outstand = "";
      this.$forceUpdate();
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    handleOk: function (evt) {
      evt.preventDefault();
      if (this.invalidFrmdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata obj : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else if (this.fileXlsx) {
        this.showUploadFrm = false;
        // this.$forceUpdate();
        this.uploadinv();
      } else {
        toastr.warn("Please select one File XLSX that want to Upload ");
      }
    },
    downloadtemplate: function () {
      arinv.downloadtemplate();
    },
    uploadinv: async function () {
      if (this.invalidFrmdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata obj : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else if (this.fileXlsx) {
        this.showUploadFrm = false;
        this.isLoading = true;
        try {
          const response = await arinv.upload(this.fileXlsx, this.frmdata);
          this.isLoading = false;
          console.log(response);
          const ada = this.artypes.find((t) => t.value == this.frmdata.artype);
          if (ada) {
            toastr.success(
              `${ada.text} , Complete sucessfully`,
              "UPLOAD/IMPORT INVOICE",
              10000
            );
          } else
            toastr.success(
              `Complete sucessfully`,
              "UPLOAD/IMPORT INVOICE",
              10000
            );
        } catch (error) {
          this.isLoading = false;
          this.showUploadFrm = true;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select one File XLSX that want to Upload ");
      }
    },
    unuploadinv: async function (evt) {
      evt.preventDefault();
      if (this.invalidPostAll) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.showUploadedCancelFrm = false;
          this.isLoading = true;
          await arinv.unupload({
            invdate: moment(this.postAllfrm.invdate).format("YYYY-MM-DD"),
            artype: this.postAllfrm.artype,
          });
          this.refresh();
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    saveFilter() {
      const keys = [
        "uraian",
        "DimCol",
        "DimVal",
        "tgl1",
        "tgl2",
        "outstand",
        "nomor",
        "customer",
        "po",
        "postgroup",
        "pack_name",
        "posting",
        "invmanual",
        "ostStatuskey",
        "custcode",
        "canceled",
        "deffered",
      ];
      let filtered = false;
      const arinvlist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          arinvlist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        arinvlist.page = this.tblData.page;
        arinvlist.limit = this.tblData.limit;
        arinvlist.sortBy = this.tblData.sortBy;
        arinvlist.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.arinvlist = arinvlist;
        this.$store.commit("filter", filter);
      }
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
      this.posting();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.print();
    },
    rowPrintkwitansi(record) {
      this.rowClicked(record);
      this.printkwitansi();
    },
    rowPrintjv(record) {
      this.rowClicked(record);
      this.printjv();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    add() {
      this.saveFilter();
      router.push({ name: "receivable.arinvfrm" });
    },
    edit: function () {
      if (this.model) {
        this.saveFilter();
        if (this.model.posting == 1) {
          router.push({
            name: "receivable.arinvfrmdisabled",
            params: { arinvKey: this.model.arinvKey },
          });
        } else {
          if (
            this.model.issuenote == "CANCELATION" ||
            this.model.issuenote == "REISSUE"
          ) {
            toastr.error(
              'Edit for this record only avlaible form menu "AR Invoice - Revision/Menu"'
            );
          } else {
            router.push({
              name: "receivable.arinvfrm",
              params: { arinvKey: this.model.arinvKey },
            });
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      try {
        this.isLoading = true;
        await arinv.remove(this.model);
        this.refresh();
        // const index= this.items.findIndex(r => (r.arinvKey==this.model.arinvKey));
        // this.items.splice(index, 1);
        this.isLoading = false;
      } catch (error) {
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      // if (this.model.arinvKey == record.arinvKey) {
      //     this.edit();
      // } else {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      // }
    },
    payment: async function () {
      if (this.model.arinvKey) {
        toastr.info("Loading Payment/Settlement Detail..", "AR Invoice", 10000);
        const row = { totalsettle: 0, outstand: 0 };
        for (var key in this.model) {
          row[key] = this.model[key];
        }
        // row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
        row.invdate = row.invdate
          ? moment(row.invdate).format("YYYY-MM-DD")
          : "";
        this.paymdata = row;
        const ds = await arinv.detailsettle(this.model);
        this.paymdata.paymLines = ds[1];
        let totalsettle = 0;
        this.paymdata.paymLines.forEach((trx) => {
          totalsettle += trx.nilaibayar || 0;
        });
        this.paymdata.totalsettle = totalsettle;
        this.$forceUpdate();
        this.showPaymentForm = true;
        this.refresh();
      } else {
        toastr.warn("Please select a row that want to be view the Payment!");
      }
    },

    postAll: async function (evt) {
      evt.preventDefault();
      if (this.invalidPostAll) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.postAll_Confirm = false;
          this.isLoading = true;
          await arinv.postall({
            invdate: moment(this.postAllfrm.invdate).format("YYYY-MM-DD"),
            artype: this.postAllfrm.artype,
          });
          this.refresh();
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    unpostAll: async function (evt) {
      evt.preventDefault();
      if (this.invalidPostAll) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.postAll_Confirm = false;
          this.isLoading = true;
          await arinv.unpostall({
            invdate: moment(this.postAllfrm.invdate).format("YYYY-MM-DD"),
            artype: this.postAllfrm.artype,
          });
          this.refresh();
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    posting: async function () {
      if (this.model) {
        if ((this.model.posting || 0) == 0) {
          this.showPostingConfirm = true;
        }
        if (this.model.posting == 1) {
          this.showUnpostConfirm = true;
        }
      } else {
        toastr.warn("Please select a row that want to be Posted!");
      }
    },
    postingData: async function () {
      this.isLoading = true;
      try {
        await arinv.posting(this.model);
        this.model.posting = 1;
        this.printjv();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    unpostData: async function () {
      this.isLoading = true;
      try {
        await arinv.postingUndo(this.model);
        this.model.posting = 0;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    editjv: function () {
      if (this.model) {
        this.saveFilter();
        const tanggal = moment(this.model.invdate).format("YYYY-MM-DD");
        router.push({
          name: "receivable.editjvfrm",
          params: { nomor: this.model.invoiceno, tanggal, kodejurnal: "ARINV" },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    printjv: async function () {
      if (this.model) {
        try {
          this.reportUrl = null; this.showReport = true;
          this.isprintjv = true;
          this.reportUrl = await arinv.printjv(this.model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    print: async function () {
      if (this.model) {
        try {
          this.reportUrl = null; this.showReport = true;
          this.isprintjv = false;
          this.reportUrl = await arinv.print(this.model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    printselected: async function () {
      if (this.selected) {
        try {
          this.reportUrl = null; this.showReport = true;
          this.isprintjv = false;
          this.reportUrl = await arinv.printbills(this.selected);
        } catch (error) {
          console.log(error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select row(s) that want to be Printed!");
      }
    },
    printkwitansi: async function () {
      if (this.model) {
        if (!this.model.kwitansidari) {
          this.kwitansi.kwitansidari = `${this.model.CustName}`;
        }
        if (!this.model.kwitansiaddr) {
          this.kwitansi.kwitansiaddr = `${this.model.Address1} ${this.model.Address2} ${this.model.City}`;
        }
        this.kwitansi.totalinv = this.model.totalinv;
        this.kwitansi.matauang = this.model.matauang;
        this.kwitansi.arinvKey = this.model.arinvKey;

        this.showKwitansiForm = true;
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    printkwitansiok: async function () {
      if (this.model) {
        try {
          this.showKwitansiForm = false;
          this.isprintjv = false;
          // if ((this.model.kwitansidari!=this.kwitansi.kwitansidari) || (this.model.kwitansiaddr != this.kwitansi.kwitansiaddr)) {kwitansiFor
          if (
            this.model.kwitansidari != this.kwitansi.kwitansidari ||
            this.model.kwitansiFor != this.kwitansi.kwitansiFor
          ) {
            await arinv.printkwitansiupdate(this.kwitansi);
          }
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await arinv.printkwitansi(this.model);
        } catch (error) {
          console.log(error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    printkwitansis: async function () {
      if (this.selected) {
        try {
          this.reportUrl = null; this.showReport = true;
          this.isprintjv = false;
          this.reportUrl = await arinv.printkwitansis(this.selected);
        } catch (error) {
          console.log(error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select row(s) that want to be Printed!");
      }
    },

    printlist: async function () {
      try {
        this.isprintjv = false;
        this.reportUrl = null; this.showReport = true;
        this.reportUrl = await arinv.printlist(this.tblData);
      } catch (error) {
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    exportData: function () {
      if (this.exportChoice === "exportcsv") {
        this.exportcsv();
      } else {
        this.exportxls();
      }
    },
    exportcsv: async function () {
      try {
        this.isLoading = true;
        const response = await arinv.exportcsv(this.tblData);
      } catch (error) {
        console.log(error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
      this.isLoading = false;
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        const response = await arinv.exportxls(this.tblData);
      } catch (error) {
        console.log(error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
      this.isLoading = false;
    },
    showActionHistory: async function (record) {
      try {
        this.model = record;
        this.isLoading = true;
        const data = await arinv.detailcollection(record);
        this.actionHistory = data;
        this.actionHistoryShow = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    close() {
      router.push("/receivable/home");
    },
  },
};
</script>
